<template>
  <vc-date-picker
    :model-value="modelValue"
    @update:model-value="onInput"
    @dayclick="onDayClick"
    :min-date="new Date()"
    is-expanded
    transparent
    borderless
    :disabled-dates="disabledDates"
    :attributes="calendarAttributes"
    class="my-calendar w-full
           [&_.vc-container]:w-full
           [&_.vc-weeks]:gap-y-1
           [&_.vc-day-content]:py-3
           [&_.vc-day-content]:min-h-[44px]"
    :style="{ width: '100%' }"
  />
</template>

<script setup>
defineProps({
  modelValue: Date,
  calendarAttributes: Array,
  disabledDates: Array
})

const emit = defineEmits(['update:modelValue', 'dayclick'])

function onInput(newValue) {
  emit('update:modelValue', newValue)
}

function onDayClick(day) {
  emit('dayclick', day.date)
}
</script>
